import { Injectable } from '@angular/core';

import { Factory } from './factory.interface';
import { Lessee } from '../Classes';
import { Lessee as LesseeT } from '../Interfaces';

@Injectable()
export class LesseeFactory implements Factory {
    constructor() { }
    createInstance(json?: (LesseeT | any)): Lessee {
        return new Lessee(json);
    }
    createInstances(jsons: (LesseeT | any)[]): Lessee[] {
        let instances: Lessee[] = [];
        jsons.forEach(json => {
            instances.push(this.createInstance(json));
        });
        return instances;
    }
    deps() {
        return [];
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Factories/lessee-factory.ts